import { render, staticRenderFns } from "./ActivitiesRecord.vue?vue&type=template&id=5c92d0eb&scoped=true"
import script from "./ActivitiesRecord.vue?vue&type=script&lang=js"
export * from "./ActivitiesRecord.vue?vue&type=script&lang=js"
import style0 from "./ActivitiesRecord.vue?vue&type=style&index=0&id=5c92d0eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c92d0eb",
  null
  
)

export default component.exports